module.exports = __webpack_public_path__ + "img/NDDLRPICK.80d544da.svg";